// Backend wiring. Populated at build time from CDK stack outputs via
// `infra/scripts/write-web-config.mjs`, which writes web/.env.production and
// web/.env.local. When these are absent (e.g. a fresh checkout with no backend
// deployed), the app runs in local-only mode: routines/progress live in
// localStorage exactly as before, and no account UI is shown.
export interface SyncConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
}

const region = import.meta.env.VITE_AWS_REGION ?? '';
const userPoolId = import.meta.env.VITE_USER_POOL_ID ?? '';
const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '';
const apiUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

/** True only when every backend value is present — gates all account/sync UI. */
export const syncEnabled: boolean = Boolean(
  region && userPoolId && userPoolClientId && apiUrl,
);

export const syncConfig: SyncConfig | null = syncEnabled
  ? { region, userPoolId, userPoolClientId, apiUrl }
  : null;
